
import isStringOrStringArray from '@/utils/isStringOrStringArray';

export default {
  name: 'AppCategorySelector',

  componentName: 'AppCategorySelector',

  props: {
    config: {
      type: Object,
      required: true
    },
    formValue: {
      type: Object,
      required: true
    }
  },

  computed: {
    categories: function categories() {
      var _this = this;

      return this.$store.getters.appCategory.map(function (item) {
        return {
          value: isStringOrStringArray(_this.formValue[_this.config.prop]) ? String(item.id) : Number(item.id), // 兼容传入参数的类型
          label: item.name
        };
      });
    }
  },

  mounted: function mounted() {
    if (this.categories && !this.categories.length) {
      this.$store.dispatch('GetAppCategoryList');
    }
  }
};